import React from 'react';
import { Box, Typography } from '@mui/joy';
import ChatListEmpty from '../../../assets/chat_list_empty.png';
import useI18n from '@mono-farmart-web/i18n/hooks/usei18n';
import { keys } from '@mono-farmart-web/i18n/Keys';

function ChatHistoryEmptyList() {
	const { t } = useI18n();
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				flex: 1,
				height: 200,
				textAlign: 'center',
				gap: 2, // Space between elements
				marginTop: 9,
			}}
		>
			<img
				src={ChatListEmpty}
				alt='No chats'
				style={{ width: '67px', height: '60px', opacity: 0.8 }}
			/>
			<Typography level='body-sm' textColor={'danger.outlinedDisabledColor'}>
				{t(keys.no_chat_found)}
			</Typography>
		</Box>
	);
}

export default React.memo(ChatHistoryEmptyList);
